var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_545_8650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6146 6.05382C20.3906 5.21172 19.7279 4.54739 18.8849 4.31971C17.3605 3.91113 11.2443 3.91113 11.2443 3.91113C11.2443 3.91113 5.13128 3.91113 3.60379 4.31971C2.76383 4.54427 2.10119 5.2086 1.87409 6.05382C1.46655 7.58209 1.46655 10.7727 1.46655 10.7727C1.46655 10.7727 1.46655 13.9634 1.87409 15.4916C2.09808 16.3337 2.76072 16.9981 3.60379 17.2258C5.13128 17.6343 11.2443 17.6343 11.2443 17.6343C11.2443 17.6343 17.3605 17.6343 18.8849 17.2258C19.7248 17.0012 20.3875 16.3369 20.6146 15.4916C21.0221 13.9634 21.0221 10.7727 21.0221 10.7727C21.0221 10.7727 21.0221 7.58209 20.6146 6.05382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29064 13.7139L14.3709 10.7727L9.29064 7.8316V13.7139Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_545_8650",
    x: 0,
    y: 0,
    width: 22,
    height: 22.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_545_8650"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.f59b2283ae7374d43d39c636199b3434.svg";
export { ForwardRef as ReactComponent };